module.exports = __webpack_public_path__ + "img/cas.6e993220.png";